const TRANSLATION_EN = {
    0: '0',
    cancel: 'Cancelar',
    delete: 'Borrar',
    howAreYouToday: '¿Cómo te encuentras hoy?',
    selectEmotion: 'Selecciona una emoción',
    question: 'Pregunta',
    settings: 'Ajustes',
    privacyPolicy: 'Política de privacidad',
    dayReview: 'Reseña del día',
    dailyReflection: 'Reflexión diaria',
    like: 'Me gusta',
    showLess: 'Mostrar menos',
    showMore: 'Mostrar más',
    search: 'Buscar',
    years: 'Grados',
    year: 'Grado',
    classes: 'Grupos',
    class: 'Grupo',
    custom: 'Personalizar',
    staff: 'Equipo de trabajo',
    allStudents: 'Todos los alumnos',
    beAmazing: '¡Se increíble!',
    login: 'Iniciar sesión',
    getStarted: 'Comenzar',
    password: 'Contraseña',
    email: 'Correo electrónico',
    requestNewPassword: 'Solicitar nueva contraseña',
    newPassword: 'Nueva contraseña',
    enterYourSchoolEmailAndWeWillSendYouALinkToGetBackIntoYourAccount: 'Ingresa tu correo institucional y te enviaremos un token de validación para reingresar a tu cuenta',
    sendRequest: 'envía solicitud',
    verifyYourEmail: 'verifica tu correo',
    weHaveSentYouALinkToGetBackIntoYourAccountAndCheckYourMailAndCopyYourTokenHere:
        'Te hemos enviado un token de validación para reingresar a tu cuenta. Revisa tu correo y copia tu token aquí',
    resendARequest: 'Reenviar solicitud',
    didntGetAMail: '¿No recibiste un correo?',
    submit: 'Enviar',
    poll: 'Sondeo',
    title: 'Título',
    message: 'Mensaje',
    anonymous: 'Anónimo',
    excellentWorkWeAreDelightedToHearThingsAreSoMuchBetter: 'Excelente trabajo! Nos encanta escuchar que las cosas están mucho mejor',
    thisIsYourSafePlaceAndNothingWillBeShared: 'Este es tu espacio seguro. Nada será compartido',
    enterANameForTodaysNotes: 'Elige un nombre para las notas de hoy',
    iDontWantToSaveNotes: 'No quiero guardas las notas',
    worse: 'Peor',
    sorryToHearThatThingsAreWorse: 'Sentimos escuchar que las cosas están peor.',
    muchWorse: 'Mucho peor',
    feelingMuchWorseQuestion: 'Sentimos escuchar que te sientes peor. ¿Cuál de las sugerencias siguientes te pueden ayudar en este momento?',
    sorryToHearThatThingsAreMuchWorse: 'Sentimos escuchar que las cosas están mucho peor.',
    same: 'Igual',
    feelingSameQuestion: '¿Qué puedes hacer en este momento para mejorar tu situación?',
    better: 'Mejor',
    feelingBetterQuestion: 'Es bueno escuchar que la situación ha mejorado. ¿Tienes ideas de cómo podrías mejorarla aún mas?',
    goodToHearThingsAreBetter: 'Es bueno saber que las cosas están mejor.',
    muchBetter: 'Mucho mejor',
    greatToHearThingsAreMuchBetterAndThinkAboutHowToImproveEvenMoreOrKeepItOnAPositiveLevel:
        'Genial saber que las cosas están mucho mejor. Piensa en cómo mejorar aun más o mantener un nivel positivo',
    suggestions: 'Sugerencias',
    loadMoreSuggestions: 'Cargar más sugerencias',
    continue: 'Continuar',
    deleteNote: 'Borrar Nota',
    today: 'Hoy',
    comparedToLastTimeTodayIamFeeling: 'Comparado a la última vez, hoy me siento',
    howDoYouFeelComparedToLastTimeYouDidThePoll: '¿Cómo te sientes en comparación a la última vez que realizaste la encuesta?',
    thisInformationWillBeSharedWith: 'Esta información se compartirá con un maestro',
    feelFreeToShareAnyThoughtsHereWhyYouFeelThisWay: 'Siéntete libre de compartir cualquier pensamiento aquí sobre el porqué te sientes de esta manera',
    feedback: 'Retroalimentación',
    choose: 'Elige un nombre para las notas de hoy',
    openTasks: 'Abrir tareas',
    newConversation: 'Nueva conversación',
    teacher: 'Maestro',
    counselor: 'Consejero',
    secretKey: 'Llave secreta',
    advancedSettings: 'Ajustes avanzados',
    termsAndConditions: 'Términos y condiciones',
    appVersion: 'Versión de la aplicación:',
    surname: 'Apellido',
    firstName: 'Nombre',
    thisIsYourPrivateRoom: 'Este es tu espacio privado',
    safePlaceWithDailyReflectionNotes: 'Espacio seguro con reflexiones diarias',
    personalInformation: 'Información personal',
    privacyAndSecurity: 'Privacidad y seguridad',
    open: 'Abierto',
    openLink: 'Abrir enlace',
    tasks: 'Tareas',
    logout: 'Salir',
    save: 'Guardar',
    name: 'Nombre',
    profile: 'Perfil',
    feed: 'Muro',
    Yes: 'Si',
    No: 'No',
    archive: 'Historial',
    yesterday: 'Ayer',
    tomorrow: 'Mañana',
    results: 'Resultados',
    required: 'Requerido',
    schedule: 'Calendario',
    happy: 'Feliz',
    worried: 'Preocupado',
    ecstatic: 'Entusiasmado',
    inspired: 'Inspirado',
    calm: 'Calmado',
    good: 'Tranquilo',
    woried: 'preocupado',
    numb: 'Desganado',
    lethargic: 'Aburrido',
    grumpy: 'Molesto',
    sad: 'Triste',
    stressed: 'Estresado',
    angry: 'Enojado',
    sunday: 'Domingo',
    monday: 'Lunes',
    tuesday: 'Martes',
    wednesday: 'Miércoles',
    thursday: 'Jueves',
    friday: 'Viernes',
    saturday: 'Sábado',
    delivered: 'Entregado',
    seen: 'Visto',
    forgotPassword: 'Olvidaste tu contraseña?',
    repeatPassword: 'Repite la contraseña',
    retypePassword: 'reintroducir contraseña',
    changePassword: 'Cambiar contraseña',
    dailyFeedback: 'Retroalimentación diaria',
    enterSurname: 'Ingresa apellido',
    newMessage: 'nuevo mensaje',
    myTasks: 'Mis tareas',
    hi: 'Hola',
    home: 'Inicio',
    comment: 'comentario',
    passwordMustBeLongerThan8CharactersAndMustContainsUppercaseLowercaseNumberAndSpecialSymbol:
        'La contraseña debe contener más de 8 caracteres, debe contener mayúsculas, minúsculas y caracteres especiales',
    enterYourWorkEmailAndPassword: 'Ingresa tu correo institucional y tu contraseña',
    submitNewPassword: 'Ingresa la nueva contraseña',
    writeYourMessageHere: 'Escribe tu mensaje aquí',
    saveAndContinue: 'Guardar y continuar',
    whatAreJust3GoodThingsThatHappenedToday: '¿Cuáles son 3 cosas buenas que ocurrieron hoy?',
    secretKeyHasBeenSaved: 'El código secreto ha sido guardado',
    enterSecretKey: 'ingresa las claves secretas',
    passwordsDoNotMatch: 'La contraseña no coincide',
    howWasYourDay: '¿Cómo estuvo tu día?',
    thankYouForReachingOutWeWillReplyToYourMessageSoonIfYouOrSomeoneYouKnowIsInImmediateDangerPleaseCallEmergencyServices: 'Gracias por contactarnos. Te responderemos pronto.',
    doYouThinkThingsAreForAnyReasonInParticular: '¿Crees que las cosas están {{result}} por alguna razón en particular?',
    yourPrivateNotes: 'Tus notas privadas',
    iDontWantToThinkAboutThisNow: 'No quiero pensar en esto ahora',
    selectLanguage: 'Seleccionar idioma',
    userIsUpdated: 'El usuario ha sido actualizado',
    privateNoteHasBeenSaved: 'La nota privada ha sido guardada',
    writePersonalNotesHere: 'Escribe tus notas personales aquí ( solo tu podrás verlas)',
    compareToLastTime: 'Comparado con la última vez',
    yourAnswerIsSaved: 'Tu respuesta ha sido guardada',
    staySecuredFirst: 'Primero mantente a salvo',
    Surveys: 'Encuestas',
    survey: 'Encuesta',
    Section: 'Sección',
    Sections: 'Secciones',
    youHaveNoChats: 'No tienes conversaciones',
    noCounselorAvailable: 'No hay ningún orientador disponible en tu escuela.',
    noSosAvailable: 'No hay ningún contacto de auxilio disponible en tu escuela.',
    noTeacherAvailable: 'No hay ningún profesor disponible para tu clase.',
    sos: 'AUXILIO',
    open_survey: 'Abrir  encuesta',
    anonymous_survey: 'Encuesta anónima',
    'Take Survey': 'Tómalo', // needs new translation
    nameOfTodayNote: 'Nombre de la nota de hoy',
    experienceIt: '% lo experimenta',
    read: 'Leer',
    received: 'recibido',
    Attention: 'Atención',
    toEnsureYourPrivacyThisKeyIsNotRecoverableAllYourNotesWillBeLostIfYouForgetThisKey:
        'Para asegurar tu privacidad, esta clave no es recuperable. ¡Todas tus notas se perderán si la olvidas!',
    anonymousPoll: 'Sondeo anónimo',
    Previous: 'Anterior',
    anonymousQuestion: 'Pregunta anónima',
    openQuestion: 'Abrir pregunta',
    open_poll: 'Abrir sondeo',
    anonymous_poll: 'Sondeo anónimo',
    solutions: 'Soluciones',
    chat: 'Conversación',
    time: 'Hora',
    congratsEverythingIsDoneForNowWaitForNewTasks: 'Felicidades, has terminado por ahora! Espera a recibir nuevas tareas',
    date: 'Fecha',
    'Write full answer here': 'Escribe tu respuesta completa aquí',
    'My Upstrive': 'Mi Upstrive',
    'Select emotion that fits your mood': 'Selecciona la emoción que se ajusta a tu estado de ánimo',
    'Select one option': 'Seleccionar una opción',
    youHaveMissedThisQuestion: 'Has olvidado esta pregunta',
    'Next section': 'Siguiente sección',
    Finish: 'Terminar',
    'Your results are saved!': '¡Tus resultados se han guardado!',
    yourAnswersAreSaved: '¡Tus respuestas han sido guardadas!',
    openJournal: 'Abrir diario',
    day: 'Día',
    'Your browser does not support HTML video': 'Tu explorador no soporta videos HTML',
    typeYourAnswerHere: 'Escribe tu respuesta aquí',
    'We hope you’ve had a good day!': '¡Esperamos que hayas tenido un día bueno!',
    'What are 3 things that are a bit challenging at the moment?': 'Cuáles son 3 cosas que son retadoras en este momento?',
    'What’s just one thing you will do differently tomorrow?': 'Qué cosa harías diferente mañana?',
    'What`s the main reason?': '¿Cuál es el motivo principal?',
    'Note has been deleted': 'La nota ha sido eliminada',
    'At least 8 characters': 'Por lo menos 8 caracteres',
    confirmDeletion: 'Confirmar eliminación',
    'Select an emotion that describes how you’re feeling': 'Selecciona una emoción que mejor describa cómo te sientes ahora',
    'Language is changed': 'Se ha cambiado el idioma',
    rememberMe: 'Recordar contraseña',
    showPassword: 'Mostrar contraseña',
    instructionVideo: 'Video instructivo',
    instructionVideos: 'Videos instructivos',
    yourTasks: 'Tus tareas',
    activitiesForCompletion: 'Actividades para completar',
    oopsThereSeemsToBeAnIssueWithConnection: 'Ups  parece que hay un problema con tu conexión',
    pleaseTryAgainInAFewMinutestOrContactUpstriveSupport: 'Por favor inténtalo de nuevo en unos minutos o contacta el Soporte de Upstrive',
    loadingMoreFeeds: 'Cargar mas contenido',
    chooseTheAnswer: 'Elige una respuesta',
    writeFullAnswerHere: 'Escribe la respuesta completa aquí',
    selectEmotionThatBestDescribesYourMoodToday: 'Selecciona una emoción que mejor describa tu estado de ánimo hoy',
    yourBrowserDoesNotSupportHTMLVideo: 'Tu navegador no soporta videos HTML',
    whatIsTheMainReason: '¿Cuál es el motivo principal?',
    pickUpTo3: 'Elige hasta 3',
    myself: 'CONMIGO MISMO/A',
    family: 'Familia',
    friends: 'Amigos',
    school: 'Escuela',
    'social media': 'Redes sociales',
    wellbeing: 'bienestar',
    health: 'salud',
    achievement: 'Logros',
    sleep: 'SUEÑO',
    typeAnyAdditionalTextHere: 'Escribe cualquier texto adicional aquí',
    howDoYouFeelComparedToLastTimeYouLoggedIn: '¿Cómo te sientes en comparación a la última vez que ingresaste?',
    iDontWantToThinkAboutItNow: 'No quiero pensar en esto ahora',
    stepBack: 'Dar un paso atrás',
    writeYourPersonalNotesHere: '',
    whatCouldYouDoToImproveThingsRightNow: '¿Qué podrías hacer para mejorar las cosas en este momento?',
    selectOneOption: 'Seleccionar una opción',
    finish: 'Terminar',
    nextSection: 'Siguiente sección',
    iHaveAnIssueRelatedTo: 'Tengo un problema relacionado a…',
    sorryYourSchoolRestrictedAccessToThisModule: 'Lo sentimos, tu institución ha restringido el acceso a este módulo',
    findTheRightSolution: 'Encuentra la solución adecuada',
    exploreThingsYouCanDoRightNow: 'Descubre cosas que puedes hacer ahora mismo',
    seeHowOtherStudentsHandleThis: 'Ve cómo otros estudiantes lidian con esto',
    connectWithTheConselor: 'Conectar con un consejero',
    quickTips: 'Tips rápidos',
    howToDealWithThisProblem: '¿Cómo lidiar con este problema?',
    thingsYouCanDoRightNow: 'Cosas que puedes hacer en este momento',
    yesThanks: '¡SI Gracias!',
    notReally: '¡No realmente!',
    expertRecommendation: 'Recomendación de experto',
    wasThisSolutionHelpful: '¿Ésta solución te fue útil?',
    send: 'Enviar',
    close: 'Cerrar',
    topic: 'Tema',
    'I Care / I Listen': 'Chat de: Me importa / Escucho',
    privateNotes: 'Notas privadas',
    yourSecretKeyIsSaved: 'Tu clave secreta se ha guardado',
    changeSecurityKey: 'Cambiar la clave de seguridad',
    passwordSetup: 'Establecer una contraseña',
    atLeast8Caracters: 'Por lo menos 8 caracteres',
    mobileAndDesktopStudentVersion: 'Versión.mp4  móvil y de escritorio - estudiante',
    weHopeYouHaveAGoodDay: '¡Esperamos que tengas un buen día!',
    whatAre3ThingsThatAreABitChallengingAtTheMoment: 'Cuáles son 3 cosas que son retadoras en este momento?',
    whatsJustOneThingYouWillDoDifferentlyTomorrow: '¿Cuál será la única cosa que harás diferente mañana?',
    typeOneThingHere: 'Escribe una cosa aquí',
    'Type 1st thing here': 'Escribe la primer cosa aquí',
    'Type 2nd thing here': null,
    'Type 3rd thing here': null,
    noteHasBeenDeleted: 'La nota ha sido eliminada',
    returnBack: 'Regresar',
    yourResultsAreSaved: '¡Tus resultados se han guardado!',
    majorUpdate: 'Major Update',
    whatsNew: '¿Qué hay de nuevo?',
    sameGreatAppFreshNewLook: 'Same great app fresh new look!',
    next: 'Siguiente',
    closePopup: 'Cerrar ventana emergente',
    completed: 'Terminado',
    'Your message is sent! Someone will contact you soon': '¡Tu mensaje se ha enviado!',
    sec: 'seg',
    'You have been logged out automatically after 15 minutes': 'Has sido expulsado automáticamente después de 15 minutos de inactividad',
    'How are you?': '¿Cómo te sientes?',
    point: 'Punto',
    points: 'Puntos',
    'You are doing great! You earned 5 points for completing survey': 'You are doing great! You earned {{value}} points for completing survey',
    'Next Video': 'Next Video',
    'Video topic': 'Video topic',
    Success: 'Success',
    'Share your feedback': 'Comparte tus comentarios',
    'Leave your feedback': 'Deja tus comentarios',
    'Tell us how we can improve Upstrive in the box below': 'Dinos cómo podemos mejorar Upstrive en el recuadro de abajo',
    'Type your feedback here': 'Escribe tus comentarios aquí',
    Achievements: 'Logros',
    'Dumo Points': 'Dumo Points',
    'Browse achievements': 'Browse achievements',
    'Achievements center': 'Achievements center',
    'Earn points by completing tasks and exchange them into rewards': 'Earn points by completing tasks and exchange them into rewards',
    '10 more points possible to earn today': '10 more points possible to earn today',
    'Check points system': 'Check points system',
    'Available points': 'Available points',
    'Our Achievements': 'Our Achievements',
    'Boost your points by earning achivements': 'Boost your points by earning achivements',
    'Daily Achievements': 'Daily Achievements',
    'Features achievements': 'Features achievements',
    'Our Rewards': 'Our Rewards',
    'Exchange your points into rewards': 'Exchange your points into rewards',
    'Transfer earned points to Dummo': 'Transfer earned points to Dummo',
    'Exchange for a reward': 'Exchange for a reward',
    'Task Description': 'Task Description',
    'Progress bar': 'Progress bar',
    'Select as goal': 'Select as goal',
    'Send earned points to DUMO': 'Select as goal',
    'Type your DUMO account here': 'Type your DUMO account here',
    'Amount of points you want to transfer': 'Amount of points you want to transfer',
    'Enter your DUMO account': 'Enter your DUMO account',
    Proceed: 'Proceed',
    'Points Earned': 'Puntos conseguidos',
    'This popup will be auto closed in': 'Esta Ventana emergente se cerrará automáticamente en',
    'Anonymous chats': 'Conversaciones anónimas',
    'Visible chats': 'Conversaciones visibles',
    'This message will be sent anonymously to your teacher, ensuring your privacy': 'Este mensaje será enviado de forma anónima a tu maestro, asegurando tu privacidad',
    'Your opinion matters to us!': '¡Tu opinión nos importa!',
    'Your feedback helps us to improve. If you find our app helpful, please consider rating it.':
        'Tu retroalimentación nos ayuda a mejorar. Si encuentras nuestra aplicación útil, por favor considera calificarla.',
    'Thank you!': '¡Gracias!',
    'Connect with Dummo account': 'Connect with Dummo account',
    'No item found': 'No item found',
    'Enter your DUMO username': 'Enter your DUMO username',
    'Write your Dummo username below': 'Write your Dummo username below',
    'Hi, connect your Dummo account': 'Hi, connect your Dummo account',
    Confirm: 'Confirmar',
    'No, cancel': 'No, cancel',
    'Yes, unlink': 'Yes, unlink',
    'Transfer points': 'Transfer points',
    'Email does not exist': '',
    'Your email address is not valid. Please ask your school admin for new password': '',
    'Invalid token, Contact Support': '',
    'Please enter username and password': '',
    "We can't find an account with this email...": 'No podemos encontrar una cuenta ligada a este correo',
    'Enter credentials you received from school': 'Ingresa las credenciales que recibiste de la escuela',
    'This is only for students...': 'Esto es solo para estudiantes',
    'Incorrect password.': 'Contraseña incorrecta',
    'Thank you for helping us to make Upstrive better.': 'Gracias por ayudarnos a mejorar Upstrive',
    deleteYourPrivateNote: '¿Borrar tus notas privadas?',
    'Delete your private note?': '¿Borrar tus notas privadas?',
    'Invalid token': '',
    Myself: 'CONMIGO MISMO/A',
    Family: 'Familia',
    Friends: 'Amigos',
    'Social media': 'Redes sociales',
    Wellbeing: 'bienestar',
    Health: 'salud',
    School: 'Escuela',
    Achievement: 'Logros',
    Sleep: 'SUEÑO',
    Received: 'recibido',
    'This day is locked!': '¡Este día esta asegurado!',
    'Finish later': 'Terminar después',
    'You have missed this question': 'Has olvidado esta pregunta',
    'Day review': 'Reseña del día',
    'Dummo account successfully connected': '',
    'Dummo points successfully transfered': '',
    'Your emotion is confirmed': '',
    'Do not agree': 'Do not agree',
    "If you don't agree to Terms and Conditions you are not going to be allowed to use the app!":
        "If you don't agree to Terms and Conditions you are not going to be allowed to use the app!",
    'You will be logged out': 'You will be logged out',
    'I do not agree': 'I do not agree',
    Continue: 'Continue',
    "I confirm that I read and agree to Upstrive's": "I confirm that I read and agree to Upstrive's",
    'Terms and Conditions': 'Terms and Conditions',
    Confidential: 'Confidential',
    'Your journal is for you only — nobody can see what you write, but your teacher can see that you’re working on it':
        'Your journal is for you only — nobody can see what you write, but your teacher can see that you’re working on it.',
    'Start Journalling!': 'Start Journalling!',
    'Boost your points by earning achievements': 'Boost your points by earning achievements',
    visitOurWebsiteForMoreDetails: 'Visit our <white>website</white> for more details.',
    //Translate text
    "I think I'm feeling this way because": "I think I'm feeling this way because ...",
    "Today's Reflection": 'La reflexión de hoy',
    'What are three good things that happened today?': '¿Cuáles son tres cosas buenas que sucedieron hoy?',
    "Name Today's Notes": 'Nombra las notas de hoy',
    "Enter a name for today's notes": 'Ingresa un nombre para las notas de hoy',
    'Skip for now': 'Omitir por ahora',
    'Go Back': 'Regresar',
    'Your Reflection Space': 'Tu espacio de reflexión',
    the: 'el',
    'Add your personal notes here - only you can see them': 'Agrega tus notas personales aquí - solo tú puedes verlas',
    'Stay Secure': 'Mantente seguro',
    'Enter your secret key': 'Ingresa tu clave secreta',
    'ordinal.first': 'primero',
    'ordinal.second': 'segundo',
    'ordinal.third': 'tercero',
    'ordinal.fourth': 'cuarto',
    'ordinal.fifth': 'quinto',
    'ordinal.sixth': 'sexto',
    'ordinal.seventh': 'séptimo',
    'ordinal.eighth': 'octavo',
    'ordinal.ninth': 'noveno',
    'ordinal.tenth': 'décimo',
    'We hope you had a good day!': '¡Esperamos que hayas tenido un buen día!',
    'What are three things that are a bit challenging at the moment?': '¿Cuáles son tres cosas que resultan un poco desafiantes en este momento?',
    'Share your thoughts here': 'Comparte tus pensamientos aquí',
    'Create a new password': 'Crea una nueva contraseña',
    'Your password must be at least 8 characters long and include an uppercase letter, a lowercase letter, a number, and a special symbol.':
        'Tu contraseña debe tener al menos 8 caracteres e incluir una letra mayúscula, una letra minúscula, un número y un símbolo especial.',
    'Enter your new password': 'Ingresa tu nueva contraseña',
    'Re-enter your new password': 'Vuelve a ingresar tu nueva contraseña',
    'Select your answer': 'Selecciona tu respuesta',

    'Confirm new password': 'Confirmar nueva contraseña',
    'Add a short title for your message': 'Agrega un título corto para tu mensaje',
    'Type your message here': 'Escribe tu mensaje aquí',
    'At least 8 characters (upper, lower, number & symbol)': 'Al menos 8 caracteres (mayúscula, minúscula, número y símbolo)',
    pinnedPosts: 'Publicaciones fijadas',
    pinned: 'Fijada',
    viewAllPinned: 'Ver todas las fijadas',
    newPinnedPosts: 'Nuevas publicaciones fijadas',
    archiveFiltersLabel: 'Filtrar tu historial',
    archiveFilterAll: 'Todo',
    archiveFilterMoods: 'Estados de ánimo',
    archiveFilterPolls: 'Sondeos',
    archiveFilterQuestions: 'Preguntas',
    archiveFilterSurveys: 'Encuestas',
    archiveFilterJournals: 'Diarios',
    archiveKindJournal: 'Diario',
    archiveReasons: 'Motivos',
    archiveYourAnswer: 'Tu respuesta',
    archiveYourAnswers: 'Tus respuestas',
    archiveSelected: 'seleccionada',
    archiveNotAnswered: 'Sin respuesta',
    archiveSurveyProgress: '{{answered}} de {{total}} respondidas',
    archiveEmptyTitle: 'Tu historial está vacío por ahora',
    archiveEmptyFilteredTitle: 'Aún no hay nada aquí',
    archiveEmptyAll: 'Cada registro, sondeo, pregunta, encuesta y entrada de diario que completes se guardará aquí.',
    archiveEmptyMood: 'Tus registros de ánimo aparecerán aquí.',
    archiveEmptyPoll: 'Los sondeos que respondas aparecerán aquí.',
    archiveEmptyQuestion: 'Las preguntas que respondas aparecerán aquí.',
    archiveEmptySurvey: 'Las encuestas que completes aparecerán aquí.',
    archiveEmptyJournal: 'Tus entradas de diario aparecerán aquí.',
    archiveGoToTasks: 'Ir a tus tareas',
    archiveErrorTitle: 'No pudimos cargar tu historial',
    archiveErrorMessage: 'Revisa tu conexión e inténtalo de nuevo.',
    archiveLoadMoreError: 'No se pudo cargar más.',
    archiveJournalProgress: '{{answered}} de {{total}} días completados',
    archiveSearchPlaceholder: 'Buscar en tu historial',
    archiveSearchClear: 'Borrar búsqueda',
    archiveNoResultsTitle: 'Sin resultados para «{{query}}»',
    archiveNoResultsMessage: 'Prueba con otra palabra o busca algo de tus respuestas.',
    archiveViewSurvey: 'Ver las {{count}} respuestas',
    archiveOpenJournal: 'Abrir diario',
    archiveCompletedOn: 'Completado el',
    archiveEnd: 'Eso es todo por ahora',
    archiveTryAgain: 'Intentar de nuevo',
}
export default TRANSLATION_EN
